import { compose, withHandlers, withProps } from 'recompose';
import { connect } from 'react-redux';
import {
  filterSelectAll as selectAll,
  filterDeselectAll as deselectAll,
  updateFilter,
} from '../../actions';
import {
  getBarberFilters,
  getBarberFilterAllChecked,
  getActiveBarberFilterIds,
} from '../../selectors';
import ReportsFilter from '../../../reportsFilter';

const BarberFilterContainer = compose(
  connect(
    state => ({
      filters: getBarberFilters(state),
      allChecked: getBarberFilterAllChecked(state),
      title: `Barbers ${getBarberFilterAllChecked(state) ? '(all)' : `(${getActiveBarberFilterIds(state).length})`}`,
    }),
    {
      selectAll,
      deselectAll,
      updateFilter,
    },
  ),
  withProps(() => ({
    showSelectAll: true,
  })),
  withHandlers({
    updateStatusViewed: props => (barber) => {
      if (barber === true) {
        return props.selectAll('barber');
      }

      if (barber === false) {
        return props.deselectAll('barber');
      }

      return props.updateFilter('barber', barber);
    },
  }),
);

export default BarberFilterContainer(ReportsFilter);
